// sync-start:coediting-constants 358393427 https://github.com/Khan/webapp/blob/master/services/ai-guide/coediting/v2/constants.go

export const partialTemplateChannelName = "coediting/partial-template";
export const placeholderStartedChannelName = "coediting/placeholder-started";
export const placeholderFinishedChannelName = "coediting/placeholder-finished";

export const placeholderKeyProperty = "$placeholder";

export const documentPromptVariable = "coeditingDocument";
export const selectionPromptVariable = "coeditingSelection";

// sync-end:coediting-constants
